// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"5ac8a59d","453":"d8fd4f0d"}[chunkId] + ".chunk.js";
};